export const productsApiUrls = {
  REQUEST_PRODUCT_URL: "/product/request",
  GET_HIGHLIGHTED_VARIANTS_URL: `/products/variants/highlights`,
  GET_VARIANT_GROUPS_BY_CATEGORY_URL: `/products/variants/grouped-by-category`,
  GET_PRODUCTS_SEARCH_URL: `/products/variants/search`,
  GET_PRODUCT_VARIANTS_URL: `/products/variants`,
  GET_PRODUCT_DETAILS_URL: (id: string) => `/products/${id}/merchant-info`,
  GET_CALCULATE_CPA_URL: (id: string) => `/products/${id}/pricing-calculator`,
  GET_LANDING_PAGE_SETTINGS_URL: (sku: string) =>
    `/product-checkouts?productId=${sku}`,
  UPDATE_LANDING_PAGE_SETTINGS_URL: (id: string) => `/product-checkouts/${id}`,
  ENABLE_LANDING_PAGE_URL: `/product-checkouts`,
  UPLOAD_PRODUCT_MEDIA_URL: `/products/images`,
};

export const SAR_TO_USD_RATE = 0.27;
